const TS_NOTE_PREFIX = '[TS_META]';

export const extractTsMetaFromNotes = (notes) => {
  if (!notes) return null;
  const line = notes
    .split('\n')
    .find((entry) => entry.trim().startsWith(TS_NOTE_PREFIX));
  if (!line) return null;
  const jsonPart = line.trim().slice(TS_NOTE_PREFIX.length).trim();
  try {
    return JSON.parse(jsonPart);
  } catch {
    return null;
  }
};

export const stripTsMetaFromNotes = (notes) => {
  if (!notes) return '';
  return notes
    .split('\n')
    .filter((line) => !line.trim().startsWith(TS_NOTE_PREFIX))
    .join('\n')
    .trim();
};

export const upsertTsMetaInNotes = (notes, metadata) => {
  const stripped = stripTsMetaFromNotes(notes);
  const metaLine = `${TS_NOTE_PREFIX} ${JSON.stringify(metadata)}`;
  return stripped ? `${stripped}\n${metaLine}` : metaLine;
};

export const SUPPLEMENTARY_TAX_OPTIONS = [
  {
    value: 'WORKDAY_FRI_22_00',
    hourlyNetAmount: 2959,
    labelKey: 'loads.ts.options.workdayFri2200'
  },
  {
    value: 'WORKDAY_FRI_00_06',
    hourlyNetAmount: 3699,
    labelKey: 'loads.ts.options.workdayFri0006'
  },
  {
    value: 'WORKDAY_FRI_06_08',
    hourlyNetAmount: 2959,
    labelKey: 'loads.ts.options.workdayFri0608'
  },
  {
    value: 'WORKDAY_NIGHT_06_08',
    hourlyNetAmount: 2591,
    labelKey: 'loads.ts.options.workdayNight0608'
  },
  {
    value: 'NON_WORKDAY_08_22',
    hourlyNetAmount: 2591,
    labelKey: 'loads.ts.options.nonWorkday0822'
  },
  {
    value: 'NON_WORKDAY_SAT_06_08',
    hourlyNetAmount: 2959,
    labelKey: 'loads.ts.options.nonWorkdaySat0608'
  },
  {
    value: 'NON_WORKDAY_SUN_22_00',
    hourlyNetAmount: 3699,
    labelKey: 'loads.ts.options.nonWorkdaySun2200'
  },
  {
    value: 'NON_WORKDAY_SUN_00_06',
    hourlyNetAmount: 2959,
    labelKey: 'loads.ts.options.nonWorkdaySun0006'
  },
  {
    value: 'NON_WORKDAY_SUN_06_08',
    hourlyNetAmount: 2591,
    labelKey: 'loads.ts.options.nonWorkdaySun0608'
  }
];

/**
 * Look up a TS option by code.
 * @param {string} optionCode
 * @param {Array} [customOptions] - Optional custom options from server (systemConfigAPI.getTariffs).
 */
export const getSupplementaryTaxOption = (optionCode, customOptions) => {
  const opts = Array.isArray(customOptions) && customOptions.length > 0
    ? customOptions
    : SUPPLEMENTARY_TAX_OPTIONS;
  return opts.find((item) => item.value === optionCode || item.code === optionCode) || null;
};

/**
 * Calculate TS total for preview.
 * @param {string} optionCode
 * @param {number} hours
 * @param {Array} [customOptions] - Optional custom options from server.
 */
export const getSupplementaryTaxTotal = (optionCode, hours, customOptions) => {
  const option = getSupplementaryTaxOption(optionCode, customOptions);
  const parsedHours = Number(hours);

  if (!option || !Number.isFinite(parsedHours) || parsedHours <= 0) {
    return 0;
  }

  return Math.round(option.hourlyNetAmount * parsedHours);
};
